import { z } from 'zod';
import { eventGuard } from '../../types/interaction-event.js';
export const oneTimeTokenContextGuard = z
    .object({
    jitOrganizationIds: z.string().array(),
    invitationId: z.string(),
    organizationInvitationId: z.string(),
    interactionEvent: eventGuard,
})
    .partial();
export var OneTimeTokenStatus;
(function (OneTimeTokenStatus) {
    OneTimeTokenStatus["Active"] = "active";
    OneTimeTokenStatus["Consumed"] = "consumed";
    OneTimeTokenStatus["Revoked"] = "revoked";
    OneTimeTokenStatus["Expired"] = "expired";
})(OneTimeTokenStatus || (OneTimeTokenStatus = {}));
export const oneTimeTokenStatusGuard = z.nativeEnum(OneTimeTokenStatus);
